import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  getMyPlan: {
    method: 'GET',
    url: `${configs.baseUrl}/api/pricing/my-plan/`,
  },
  getMyPlanWithStripeSnapshot: {
    method: 'GET',
    url: `${configs.baseUrl}/api/pricing/my-plan/?useSnapshotStripeInfo=true`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}
const getMyPlan = () => {
  const params = { useSnapshotStripeInfo: true }
  return resource.getMyPlan(params)
}

export default {
  initResource,
  getMyPlan,
}
